import React, {PureComponent} from 'react'
import cn from 'classnames'
import injectSheet from 'react-jss'
import SVGSymbol from "../SVGSymbol"
import facebookImage from "../../img/icons/facebook.svg"
import twitterImage from "../../img/icons/twitter.svg"
import instagramImage from "../../img/icons/instagram.svg"
import pinterestImage from "../../img/icons/pinterest.svg"
import youtubeImage from "../../img/icons/youtube.svg"

class SocialLinks extends PureComponent {

    render() {
        const {classes, className, global, iconClassName} = this.props;
        if(!global) return null;

        const liClassName = cn(classes.iconLink, iconClassName);

        const socialLinks = [
            global.instagram_link && <li key={0}><a className={liClassName} href={global.instagram_link} target="_blank"><SVGSymbol icon={instagramImage} /></a></li>,
            global.facebook_link && <li key={1}><a className={liClassName} href={global.facebook_link} target="_blank"><SVGSymbol icon={facebookImage} /></a></li>,
            global.twitter_link && <li key={2}><a className={liClassName} href={global.twitter_link} target="_blank"><SVGSymbol icon={twitterImage} style={{height: 16}} /></a></li>,
            global.youtube_link && <li key={3}><a className={liClassName} href={global.youtube_link} target="_blank"><SVGSymbol icon={youtubeImage} /></a></li>,
            global.pinterest_link && <li key={4}><a className={liClassName} href={global.pinterest_link} target="_blank"><SVGSymbol icon={pinterestImage} /></a></li>
        ].filter(x => x)

        return <ul className={cn(classes.iconLinks, className)}>{socialLinks}</ul>
    }
}

export default injectSheet((theme) => (
    {
        iconLinks: {
            display: 'flex',
            alignItems: 'center',
            margin: '0 -0.5rem',
            padding: 0,
            "& > li": {
                display: 'block'
            },
            justifyContent: 'center',
            [theme.breakpoint('mobile')]: {
                justifyContent: 'flex-start',
            }
        },
        iconLink: {
            margin: "0 0.5rem",
            transition: "color 0.3s",
            display: "flex",
            color: theme.colors.white,
            "&:hover": {
                color: theme.colors.primary
            },
        },

    }
))(SocialLinks)



// WEBPACK FOOTER //
// ./src/components/Widgets/SocialLinks.js